import { Injectable, Output, EventEmitter } from '@angular/core';
import { SolApiService } from 'src/app/services/sol-api.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SideMenuService {


  data: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  getMenuItems: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null)
  // pageSlug: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  fraudMenuItems = [];
  allMenuItems = [];
  @Output() fraud = new EventEmitter<boolean>();
  @Output() menuItems = new EventEmitter<any>();
  @Output() currentActive = new EventEmitter<any>();

  constructor(private apiService: SolApiService) {
    // this.allMenuItems = [
    //   {
    //     mainId: 'fraud',
    //     items: [
    //       {
    //         id: 'GeneralStandards',
    //         title: 'معايير عامة للتعرف على النصب و الاحتيال',
    //         title_en: 'General standards to identify fraud',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/fraud/GeneralStandards',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'Types',
    //         title: 'أنواع النصب و الاحتيال',
    //         title_en: 'Types of Fraud',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/fraud',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'VictimToScam',
    //         title: 'هل وقعت ضحية نصب واحتيال؟',
    //         title_en: 'Have you ever been trapped as a victim of fraud?',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/fraud/VictimToScam',
    //         itemChilds: []
    //       }
    //     ]
    //   },
    //   {
    //     mainId: 'mediacenter',
    //     items: [
    //       {
    //         id: 'News',
    //         title: 'الاخبار',
    //         title_en: 'News',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/mediacenter/news',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'MediaGallery',
    //         title: 'مكتبة الوسائط',
    //         title_en: 'Multimedia Library',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/mediacenter/mediagallery',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'Events',
    //         title: 'الفعاليات',
    //         title_en: 'Events',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/mediacenter/events',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'ImportantLinks',
    //         title: 'روابط هامة',
    //         title_en: 'Important Links',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/mediacenter/importantlinks',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'FAQ',
    //         title: 'الأسئلة الشائعة',
    //         title_en: 'FAQs',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/mediacenter/faq',
    //         itemChilds: []
    //       }
    //     ]
    //   },
    //   {
    //     mainId: 'ShareYourExperience',
    //     items: [
    //       {
    //         id: 'UsersExperience',
    //         title: 'تجارب المستهلكين',
    //         title_en: 'Consumers Experinces',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/ShareYourExperience/UsersExperience',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'RealStories',
    //         title: 'قصص واقعيه',
    //         title_en: 'Real Stories',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/ShareYourExperience/RealStories',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'AddExperience',
    //         title: 'إضافة تجربة جديدة',
    //         title_en: 'Add a new experince',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/ShareYourExperience/AddExperience',
    //         itemChilds: []
    //       }
    //     ]
    //   },
    //   {
    //     mainId: 'AboutTheProgram',
    //     items: [
    //       {
    //         id: 'TermsOfUse',
    //         title: 'شروط الإستخدام',
    //         title_en: 'Usage Policy',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/AboutTheProgram/TermsOfUse',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'UsePolicy',
    //         title: 'شروط الخصوصية',
    //         title_en: 'Privacy Policy',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/AboutTheProgram/UsePolicy',
    //         itemChilds: []
    //       },
    //       {
    //         id: 'ContactUs',
    //         title: 'اتصل بنا',
    //         title_en: 'Contact Us',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/AboutTheProgram/ContactUs',
    //         itemChilds: []
    //       }
    //     ]
    //   },
    //   {
    //     mainId: 'profile',
    //     items: [
    //       {
    //         id: 'profileForm',
    //         title: 'البيانات الشخصية',
    //         title_en: 'Personal Information',
    //         itemIcon: 'fas fa-angle-left fa-xs',
    //         itemLink: '/pages/profilePage',
    //         itemChilds: []
    //       },
    //       // {
    //       //   id: 'changepasswordForm',
    //       //   itemTitle: 'تغيير كلمة المرور',
    //       //   title_en: 'Change Password',
    //       //   itemIcon: 'fas fa-angle-left fa-xs',
    //       //   itemLink: '/pages/profilePage/changePassword',
    //       //   itemChilds: []
    //       // }
    //     ]
    //   }
    // ];
  }


  setMenuItems(data, menuItems?) {
    if (menuItems) {
      localStorage.setItem('menuItems', JSON.stringify(menuItems))
      this.allMenuItems = menuItems;
    }
    else {
      this.allMenuItems = JSON.parse(localStorage.getItem("menuItems"));
    }
    this.data.next(data);
    this.fraud.emit(false);
    if (data) {
      if (data.slug == 'fraudTypes') {
        this.getFraudMenuItems();
      }
      else {
        this.fraud.emit(false);

        setTimeout(() => {
          this.allMenuItems.forEach(item => {
            if (data.id) {
              if (item.id == data.id) {
                this.menuItems.emit(item.pages);
              }
            }
            else {
              if (item.slug == data.slug) {
                this.menuItems.emit(item.pages);
              }
            }
          });
        }, 500);

      }
    }
    // this.data.next(data);
  }
  // for fraud submenu api to get types
  getFraudMenuItems() {
    setTimeout(() => {
      this.apiService
        .get(false, 'fraudTypesWithEachSub', {})
        .subscribe(result => {
          this.fraud.emit(true);
          this.fraudMenuItems = result.data.fraudTypes;
          this.menuItems.emit(this.fraudMenuItems);
        });
    });
  }

  setCurrentActive(tab: string) {
    this.currentActive.emit(tab);
  }
}
